export const SEGMENT_COLORS = [
  "blue",
  "red",
  "green",
  "yellow",
  "purple",
] as const;

export type SegmentColor = (typeof SEGMENT_COLORS)[number];

export const SEGMENT_COLOR_BG_CLASSES: Record<SegmentColor, string> = {
  blue: "bg-[var(--chart-2-subtle)]",
  red: "bg-[var(--chart-3-subtle)]",
  green: "bg-[var(--signal-positive-subtle)]",
  yellow: "bg-[var(--chart-4-subtle)]",
  purple: "bg-[var(--chart-5-subtle)]",
};

export const SEGMENT_COLOR_TEXT_CLASSES: Record<SegmentColor, string> = {
  blue: "text-[var(--chart-2-fg)]",
  red: "text-[var(--chart-3-fg)]",
  green: "text-[var(--signal-positive-foreground)]",
  yellow: "text-[var(--chart-4-fg)]",
  purple: "text-[var(--chart-5-fg)]",
};

const isSegmentColor = (color: string): color is SegmentColor =>
  (SEGMENT_COLORS as readonly string[]).includes(color);

export const getSegmentColorBgClass = (
  color: string | null | undefined,
): string =>
  color && isSegmentColor(color)
    ? SEGMENT_COLOR_BG_CLASSES[color]
    : SEGMENT_COLOR_BG_CLASSES.blue;
